export default __webpack_public_path__ + "static/media/join_button.56c6d55b.svg";